import { ImagePicture } from 'approot/shared/images/images';

import contentInfoAvif from './content-info.avif';
import contentInfoWebp from './content-info.webp';
import contentInfoPng from './content-info.png';

const ImageContentInfo = ({ width }: { width?: number }) => (
  <ImagePicture
    lazyLoad
    style={width ? { width } : undefined}
    avif={{ path: contentInfoAvif }}
    webp={{ path: contentInfoWebp }}
    png={{ path: contentInfoPng }}
  />
);

export default ImageContentInfo;
